<template>
    <div class="buyerBindingSetting">
        <el-dialog title="买家绑定设置" :visible.sync="centerDialogVisible" :show-close="false" :close-on-click-modal='false' width="600px">
            <div class="settingBox">
                <div class="bindingValidity">
                    <p class="title">绑定有效期</p>
                    <div class="radioBox">
                        <el-radio v-model="settingData.clientbinddays" :label="0">永久有效</el-radio>
                        <br>
                        <el-radio v-model="settingData.clientbinddays" :label="1">
                            <el-input v-model="settingData.validate" :disabled="settingData.clientbinddays !== 1" placeholder="1～999"></el-input>
                            <span class="text2">天内有效</span>
                            <span class="tips">到期后，客户会自动解锁，需重新推广客户</span>
                        </el-radio>
                    </div>
                </div>
                <div class="answerStting">
                    <p class="title">允许抢客<i class="el-icon-info"></i></p>
                    <div class="radioBox">
                        <el-popover placement="top" width="200" v-model="visible" trigger="hover">
                            <p class="tips">开启后： 推广员A的客户a，扫描推广员B的 推广码后，a会变成B的客户</p>
                            <el-radio slot="reference" v-model="settingData.changeclientbinddays" :label="1">
                                <span class="text1">自绑定起</span>
                                <el-input v-model="settingData.bindnum" :disabled="settingData.changeclientbinddays !== 1" placeholder="1～999"></el-input>
                                <span class="text2">天后，客户才能被抢走</span>
                            </el-radio>
                        </el-popover>
                        <br>
                        <el-radio v-model="settingData.changeclientbinddays" :label="0">不允许抢客</el-radio>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="affirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { setTimeout } from 'timers';
export default {
    name: 'buyerBindingSetting',
    data() {
        return {
            centerDialogVisible: false,
            settingData: {
                clientbinddays: 1,
                validate: '15',
                changeclientbinddays: 0,
                bindnum: ''
            },
            visible: false
        }
    },
    props: ['data'],
    methods: {
        affirm() {
            let flag = false
            let numRegular = /^[1-9]\d*$/
            if (this.settingData.clientbinddays === 1 || this.settingData.changeclientbinddays === 1) {
                if (!this.settingData.validate && this.settingData.clientbinddays === 1) {
                    this.$message.error('请输入有效天数！')
                } else if (!this.settingData.bindnum && this.settingData.changeclientbinddays === 1) {
                    this.$message.error('请输入多少天后，允许客户被抢走！')
                } else if (!numRegular.test(this.settingData.validate) || !numRegular.test(this.settingData.bindnum)) {
                    this.$message.error('请输入正整数！')
                } else {
                    this.centerDialogVisible = false
                    this.$emit('setParams', this.settingData)
                }
            } else {
                this.$emit('setParams', this.settingData)
                this.centerDialogVisible = false
            }
        },
        cancel() {
            this.changeValue()
            this.centerDialogVisible = false
        },
        changeValue() {
            if (this.data.clientbindmode === 4) {
                if (this.data.changeclientbinddays) {
                    this.settingData.bindnum = this.data.changeclientbinddays
                    this.settingData.changeclientbinddays = 1
                } else {
                    this.settingData.changeclientbinddays = 0
                }
                if (this.data.clientbinddays) {
                    this.settingData.validate = this.data.clientbinddays
                    this.settingData.clientbinddays = 1
                } else {
                    this.settingData.clientbinddays = 0
                }
            }
        }
    },
    watch: {
        'data': {
            handler() {
                this.changeValue()
            },
            deep: true
        }
    }
}
</script>
<style lang="scss">
    .buyerBindingSetting{
        .el-dialog{
            .settingBox{
                .bindingValidity, .answerStting{
                    display: flex;
                    .title{
                        color: #606266;
                        width: 75px;
                        .el-icon-info{
                            color: #C0C4CC;
                            margin-left: 5px;
                        }
                    }
                    .radioBox{
                        margin-left: 26px;
                        // .el-popover{
                        //     padding: 16px 14px !important;
                        //     top: 150px !important;
                        // }
                        .tipsBox{
                            padding: 18px 20px !important;
                        }
                        .el-radio{
                            margin-bottom: 10px;
                            color: #303133;
                            .el-input{
                                width: 70px;
                                height: 32px;
                            }
                            .text1{
                                margin-right: 10px;
                            }
                            .text2{
                                margin-left: 10px;
                            }
                            .tips{
                                color: #909399;
                                margin-left: 10px;
                            }
                            .el-radio__input.is-checked+.el-radio__label{
                                color: #303133;
                                .tips{
                                    color: #909399;
                                }
                            }
                        }
                    }
                }
                .answerStting{
                    margin-top: 20px;
                    .title{
                        padding-top: 10px;
                    }
                }
            }
        }
    }
    .el-popover{
        .tips{
            padding: 10px;
        }   
    }
</style>